import { render, staticRenderFns } from "./UOttawaLabNotebookFr.vue?vue&type=template&id=2e214966&scoped=true&"
import script from "./UOttawaLabNotebookFr.vue?vue&type=script&lang=ts&"
export * from "./UOttawaLabNotebookFr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e214966",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
